import { useTranslation } from 'react-i18next'
import React from 'react'

import { PermissionChecker } from '../../session'
import ChangeAvailabilityStatusForm from './ChangeAvailabilityStatusForm'
import ControlledModal from '../../../components/modals/ControlledModal'
import { Title } from '../../../packages/kiti/components/presentation/Text'

const ChangeAvailabilityStatusModal = props => {
  const { t } = useTranslation('availability')

  return (
    <ControlledModal width="32rem" {...props}>
      <PermissionChecker permission="editPlaceAvailabilityStatus">
        <Title size="h5" bold>
          {t('modals.changeAvailabilityStatus')}
        </Title>

        <ChangeAvailabilityStatusForm />
      </PermissionChecker>
    </ControlledModal>
  )
}

export default ChangeAvailabilityStatusModal
